import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'
import routerPrepaid from "@router/route-prepaid";
import routerReservation from "@router/route-reservation";
import routerPage from "@router/route-page";
import routerMember from "@router/route-member";
import routeHotel from "@router/route-hotel";
import routeCheckout from "@router/route-checkout";
import routeLogin from "@router/route-login";
import routeComment from "@router/route-comment";
import routeDeposit from "@router/route-deposit";
import routelevel from "@router/route-level";
import routeCart from "@router/route-cart";

export default [
  ...routeLogin,
  ...routerPage,
  ...routerMember,
  ...routerPrepaid,
  ...routerReservation,
  ...routeHotel,
  ...routeCheckout,
  ...routeComment,
  ...routeDeposit,
  ...routelevel,
  ...routeCart,
  {
    path: '/service-unavailable',
    name: 'service-unavailable',
    component: () => lazyLoadView(import('@views/ServiceUnavailable/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if (!store.state.merchant?.currentMerchant) {
            await store.dispatch('merchant/init')
          }
          if (store.getters['merchant/isSiteEnabled'] || store.getters['merchant/hasHotelModule']) {
            return next({ name: 'home', replace: true })
          }
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
  },
  // 404
  {
    path: '/404',
    name: '404',
    component: require('@src/views/_404').default,
    props: true,
  },
  // Test
  {
    path: '/test/fbchat',
    name: 'test-fbchat',
    component: () => lazyLoadView(import('@src/views/Test/FbChat')),
    meta: {
      isDevelopmentPage: true
    }
  },
  // Test
  {
    path: '/test/mock',
    name: 'test-mock',
    component: () => lazyLoadView(import('@src/views/Test/Mock')),
    meta: {
      isDevelopmentPage: true
    }
  },
  // Style Guide
  {
    path: '/style-guide',
    name: 'style-guide',
    component: () => lazyLoadView(import('@src/views/StyleGuide/Index')),
    meta: {
      isDevelopmentPage: true
    }
  },
  {
    path: '*',
    redirect: '404',
  },
]
